import React, {ReactElement} from 'react'
import AdminAuthRepository from './components/login/repository/AdminAuthRepository'
import NatAdminLoginPage from './components/login/NatAdminLoginPage'
import NatCondominiumRepo from './components/condominium/repository/NatCondominiumRepo'
import NatAdminUserRepo from './components/adminUser/repository/NatAdminUserRepo'
import NatRoomToResidentRepo from './components/roomToResident/repository/NatRoomToResidentRepo'
import NatCondominiumGroupRepo from './components/condominiumGroup/repository/NatCondominiumGroupRepo'
import NatScheduleRepo from './components/schedule/repository/NatScheduleRepo'
import NatEventRepo from './components/event/repository/NatEventRepo'
import NatRidgeRepo from './components/ridge/repository/NatRidgeRepo'
import NatMessageRepo from './components/message/repository/NatMessageRepo'
import NatAdminCondominiumListPage from './components/condominium/NatAdminCondominiumListPage'
import NatAdminCondominiumPage from './components/condominium/NatAdminCondominiumPage'
import NatAdminCondominiumRegisterPage from './components/condominium/NatAdminCondominiumRegisterPage'
import NatAdminCondominiumEditPage from './components/condominium/NatAdminCondominiumEditPage'
import NatAdminCondominiumFacilityReserveIntroductoryPage
    from './components/condominium/NatAdminCondominiumFacilityReserveIntroductoryPage.tsx'
import NatAdminAdminUserListPage from './components/adminUser/NatAdminAdminUserListPage'
import NatAdminAdminUserRegisterPage from './components/adminUser/NatAdminAdminUserRegisterPage'
import NatAdminAdminUserEditPage from './components/adminUser/NatAdminAdminUserEditPage'
import NatAdminResidentUserListPage from './components/residentUser/NatAdminResidentUserListPage'
import NatAdminResidentUserRegisterPage from './components/residentUser/NatAdminResidentUserRegisterPage'
import NatAdminResidentUserDetailsPage from './components/residentUser/NatAdminResidentUserDetailsPage'
import NatAdminResidentUserEditPage from './components/residentUser/NatAdminResidentUserEditPage'
import NatAdminAdminUserPage from './components/adminUser/NatAdminAdminUserPage'
import NatAdminMessageListPage from './components/message/NatAdminMessageListPage'
import NatAdminMessageRegisterPage from './components/message/NatAdminMessageRegisterPage'
import NatAdminMessagePage from './components/message/NatAdminMessagePage'
import NatAdminMessageEditPage from './components/message/NatAdminMessageEditPage'
import NatCurrentDateTimeRepo from './components/currentDateTime/repository/NatCurrentDateTimeRepo'
import NatHolidayMasterRepo from './components/holiday/repository/NatHolidayMasterRepo'
import NatLifeNoteRepo from './components/lifeNote/repository/NatLifeNoteRepo'
import NatAdminLifeNoteListPage from './components/lifeNote/NatAdminLifeNoteListPage'
import NatAdminLifeNoteDetailsPage from './components/lifeNote/NatAdminLifeNoteDetailsPage'
import NatSessionRepo from './components/session/repository/NatSessionRepo'
import NatAdminCondominiumGroupEditPage from './components/condominiumGroup/NatAdminCondominiumGroupEditPage'
import NatLoginBeforeMessageRepo from './components/loginBeforeMessage/repository/NatLoginBeforeMessageRepo'
import NatAdminLoginBeforeMessageListPage from './components/loginBeforeMessage/NatAdminLoginBeforeMessageListPage'
import NatAdminLoginBeforeMessagePage from './components/loginBeforeMessage/NatAdminLoginBeforeMessagePage'
import NatAdminLoginBeforeMessageRegisterPage
    from './components/loginBeforeMessage/NatAdminLoginBeforeMessageRegisterPage'
import NatAdminLoginBeforeMessageEditPage from './components/loginBeforeMessage/NatAdminLoginBeforeMessageEditPage'
import NatAdminCalendarPage from './components/calendar/NatAdminCalendarPage'
import NatAdminClosedSettingPage from './components/closedSetting/NatAdminClosedSettingPage'
import NatClosedSettingRepo from './components/closedSetting/repository/NatClosedSettingRepo'
import NatOwnerCondominiumRepo from './components/ownerCondominium/repository/NatOwnerCondominiumRepo'
import NatAdminChangePasswordInputPage from './components/adminUser/NatAdminChangePasswordInputPage'
import NatMenuMasterRepo from './components/menuMaster/repository/NatMenuMasterRepo'
import NatUseFunctionMasterRepo from './components/useFunctionMaster/repository/NatUseFunctionMasterRepo'
import NatAdminCondominiumAuthoritySettingPage
    from './components/condominiumAuthoritySetting/NatAdminCondominiumAuthoritySettingPage'
import NatCondominiumAuthoritySettingRepo
    from './components/condominiumAuthoritySetting/repository/NatCondominiumAuthoritySettingRepo'
import NatAdminAuthenticationKeyDownloadPage from './components/roomToResident/NatAdminOutputAuthenticationKeyPage'
import EventEmitterExAdmin from '../components/shared/pageBaseComponents/EventEmitterExAdmin'
import NatAdminScheduleRegisterPage from './components/schedule/NatAdminScheduleRegisterPage'
import NatAdminScheduleUpdatePage from './components/schedule/NatAdminScheduleUpdatePage'
import NatAdminScheduleDetailsPage from './components/schedule/NatAdminScheduleDetailsPage'
import NatAdminEventDetailsPage from './components/event/NatAdminEventDetailsPage'
import NatAdminEventEditPage from './components/event/NatAdminEventEditPage'
import NatAdminLifeNoteRegisterPage from './components/lifeNote/NatAdminLifeNoteRegisterPage'
import NatAdminLifeNoteEditPage from './components/lifeNote/NatAdminLifeNoteEditPage'
import NatAdminApartAssocInfoListPage from './components/apartAssocInfo/NatAdminApartAssocInfoListPage'
import NatApartAssocInfoRepo from './components/apartAssocInfo/repository/NatApartAssocInfoRepo'
import NatAdminApartAssocInfoDetailsPage from './components/apartAssocInfo/NatAdminApartAssocInfoDetailsPage'
import NatAdminApartAssocInfoRegisterPage from './components/apartAssocInfo/NatAdminApartAssocInfoRegisterPage'
import NatAdminApartAssocInfoEditPage from './components/apartAssocInfo/NatAdminApartAssocInfoEditPage'
import NatAdminSystemErrorPage from './components/error/NatAdminSystemErrorPage'
import NatFacilityRepo from './components/facility/repository/NatFacilityRepo'
import NatFacilityReserveRepo from './components/facilityReserve/repository/NatFacilityReserveRepo'
import NatAdminFacilityReserveBillingDataPage from './components/facilityReserve/NatAdminFacilityReserveBillingDataPage'
import NatAdminFacilityIntroductoryPage from './components/facility/NatAdminFacilityIntroductoryPage'
import NatAdminFacilityIntroductoryEditPage from './components/facility/NatAdminFacilityIntroductoryEditPage'
import NatAdminAdditionalBillingListPage from './components/facilityReserve/NatAdminAdditionalBillingListPage'
import NatAdminAdditionalBillingPage from './components/facilityReserve/NatAdminAdditionalBillingPage'
import NatAdminAdditionalBillingegisterPage from './components/facilityReserve/NatAdminAdditionalBillingRegisterPage'
import FacilitiesRepository from '../components/facilities/FacilitiesRepository'
import NatAdminAdditionalBillingEditPage from './components/facilityReserve/NatAdminAdditionalBillingEditPage'
import NatFacilityReserveListPage from './components/facilityReserve/NatFacilityReserveListPage'
import NatAdminFacilityReservePage from './components/facilityReserve/NatAdminFacilityReservePage'
import NatAdminFacilityReserveEditPage from './components/facilityReserve/NatAdminFacilityReserveEditPage'
import {ReserveFacilityModel} from '../components/reservations/ReserveFacilityModel'
import HolidaysRepository from '../components/HolidaysRepository'
import {ReservationsRepositoryForAdmin} from '../components/reservations/admin/ReservationsRepositoryForAdmin'
import NatAdminResidentUserEditForAdminNamePage
    from './components/residentUser/NatAdminResidentUserEditForAdminNamePage'
import NatBulletinBoardRepo from './components/bulletinBoard/repository/NatBulletinBoardRepo'
import NatAdminBulletinBoardThreadListPage from './components/bulletinBoard/NatAdminBulletinBoardThreadListPage'
import NatAdminBulletinBoardThreadPage from './components/bulletinBoard/NatAdminBulletinBoardThreadPage'
import NatAdminBulletinBoardThreadCommentPage from './components/bulletinBoard/NatAdminBulletinBoardThreadCommentPage'
import NatAdminBulletinBoardThreadRegisterPage from './components/bulletinBoard/NatAdminBulletinBoardThreadRegisterPage'
import NatAdminBulletinBoardThreadCommentRegisterPage
    from './components/bulletinBoard/NatAdminBulletinBoardThreadCommentRegisterPage'
import {PersonalInfoExtractHistoryRepo} from '../components/PersonalInfoExtractHistoryRepo'
import NatAreaCodeRepo from './components/areaCode/repository/NatAreaCodeRepo'
import NatAdminAreaCodeRegisterPage from './components/areaCode/NatAdminAreaCodeRegisterPage'
import NatAdminAreaCodeEditPage from './components/areaCode/NatAdminAreaCodeEditPage'
import NatAdminAreaCodePage from './components/areaCode/NatAdminAreaCodePage'
import NatAdminAreaCodeListPage from './components/areaCode/NatAdminAreaCodeListPage'
import NatMaintenanceSettingMasterRepo from './components/maintenance/repository/NatMaintenanceSettingMasterRepo'
import NatAdminMaintenanceForResidentPage from './components/maintenance/NatAdminMaintenanceForResidentPage'
import NatExtractHistoryRepo from './components/extract/repository/NatExtractHistoryRepo'
import NatAdminExtractHistoryList from './components/extract/NatAdminExtractHistoryList'
import NatAdminResidentUserBulkUpdatePage from './components/residentUser/NatAdminResidentUserBulkUpdatePage'
import NatAdminResidentUserApplyList from './components/residentUser/NatAdminResidentUserApplyList'
import NatAdminResidentUserApply from './components/residentUser/NatAdminResidentUserApply'
import NatAdminResidentUserApplyPage from './components/residentUser/NatAdminResidentUserApplyPage'
import NatAdminResidentUserApplyEditPage from './components/residentUser/NatAdminResidentUserApplyEditPage'
import NatAdSSOLoginRedirectPage from './components/sso/NatAdminAdSSOLoginRedirectPage'
import NatAdminResidentUserStatusConfirmationPage
    from './components/residentUser/NatAdminResidentUserStatusConfirmationPage'
import NatAssocLoginPage from '../components/login/AdminAssocLoginPage'
import AdminLoginPortalPage from '../components/login/AdminLoginPortalPage'
import NatAdminContactAddressOnEmergencyPage
    from './components/applications/contactAddressOnEmergencies/NatAdminContactAddressOnEmergencyPage'
import {NatApplicationRepo} from './components/applications/repository/NatApplicationRepo'
import NatAdminApplicationPage from './components/applications/application/NatAdminApplicationPage'
import NatAdminParkingUsesPage from './components/applications/parkingUses/NatAdminParkingUsesPage'
import NatAdminParkingUsesChangePage from './components/applications/parkingUsesChange/NatAdminParkingUsesChangePage'
import NatAdminBicycleParkingUseApplyPage
    from './components/applications/bicycleParkingUses/NatAdminBicycleParkingUseApplyPage'
import NatAdminBikeParkingUseApplyPage from './components/applications/bikeParkingUses/NatAdminBikeParkingUseApplyPage'
import NatAdminPetBreedingPage from './components/applications/petBreeding/NatAdminPetBreedingPage'
import NatAdminResidentAuthKeyNoticeApply from './components/residentUser/NatAdminResidentAuthKeyNoticeApply'
import NatAdminPetMedicalCheckUpReportPage
    from './components/applications/petMedicalCheckUpReport/NatAdminPetMedicalCheckUpReportPage'
import NatAdminConstructionsPage from './components/applications/constructions/NatAdminConstructionPage'
import NatAdminConstructionCompletePage
    from './components/applications/constructionComplete/NatAdminConstructionCompletePage'
import NatAdminBikeParkingUseChangeApplyPage
    from './components/applications/bikeParkingUsesChange/NatAdminBikeParkingUseChangeApplyPage'
import NatAdminBicycleParkingUseWithdrawalPage
    from './components/applications/bicycleParkingUseWithdrawal/NatAdminBicycleParkingUseWithdrawalPage'
import NatAdminPetBreedingStopPage from './components/applications/petBreedingStop/NatAdminPetBreedingStopPage'
import NatAdminParkingUsesWithdrawalPage
    from './components/applications/parkingUsesWithdrawal/NatAdminParkingUsesWithdrawalPage'
import NatAdminBikeParkingUseWithdrawalApplyPage
    from './components/applications/bikeParkingUsesWithdrawal/NatAdminBikeParkingUseWithdrawalApplyPage'
import NatAdminWindowFilmAttachPage from './components/applications/windowFilmAttaches/NatAdminWindowFilmAttachPage'
import NatAdminBrowsePage from './components/applications/browses/NatAdminBrowsePage'
import NatAdminLongAbsencePage from './components/applications/longAbsence/NatAdminLongAbsencePage'
import NatAdminHeavyLoadsCarryPage from './components/applications/heavyLoadsCarries/NatAdminHeavyLoadsCarryPage'
import NatAdminReportPublishingScopePage
    from './components/assocWorkReports/assocWorkReport/NatAdminReportPublishingScopePage'
import NatOwnershipTransferPage from './components/ownershipTransfers/admin/NatOwnershipTransferPage'
import {NatAssocWorkReportRepo} from './components/assocWorkReports/repository/NatAssocWorkReportRepo'
import {NatFileRepo} from './components/files/repository/NatFileRepo'
import NatAdminOwnershipTransferListPage from './components/ownershipTransfers/admin/NatAdminOwnershipTransferListPage'
import {NatOwnershipTransfersRepo} from './components/ownershipTransfers/repository/NatOwnershipTransfersRepo'
import NatOwnershipTransferCompletedPage from './components/ownershipTransfers/admin/NatOwnershipTransferCompletedPage'

import NatAdminOwnershipTransfersRegisterPage
    from './components/ownershipTransfers/admin/NatAdminOwnershipTransfersRegisterPage'
import NatAdminUserRegistrationApplyListPage
    from './components/applications/residentUserRegistration/admin/NatAdminUserRegistrationApplyListPage';
import NatRoomNumberRepo from './components/roomNumber/repository/NatRoomNumberRepo'
import AssocManagementRepository from '../components/assocDirector/AssocManagementRepository'
import AdminAssocStatusListPage from '../components/assocDirector/AdminAssocStatusListPage'
import {AdminSessionUtil} from '../app/AdminSessionUtil'
import {Location, Route} from 'react-router-dom'
import RouterPropsInjector from '../components/shared/RouterPropsInjector'
import NatAdminUserRegistrationApplyPage
    from './components/applications/residentUserRegistration/admin/NatAdminUserRegistrationApplyPage';
import NatResidentUserRepo from './components/residentUser/repository/NatResidentUserRepo';
import NatAssocAfterLoginCushion from './components/login/NatAssocAfterLoginCushion';
import NatDisasterRepo from './components/disaster/repository/NatDisasterRepo'
import NatAdminDisasterPreventionsPage from './components/disaster/NatAdminDisasterPreventionsPage'
import NatAdminDisasterPreventionsDetailsPage from './components/disaster/NatAdminDisasterPreventionsDetailsPage'
import NatAdminDisasterTopicRegister from './components/disaster/NatAdminDisasterTopicRegister'
import NatAdminDisasterPreventionRegisterPage from './components/disaster/NatAdminDisasterPreventionRegisterPage'
import NatAdminDisasterTopicListPage from './components/disaster/NatAdminDisasterTopicListPage'
import NatAdminDisasterTopicEdit from './components/disaster/NatAdminDisasterTopicEdit'
import NatAdminDisasterModeStatusListPage from './components/disaster/NatAdminDisasterModeStatusListPage'
import NatAdminDisasterPreventionEditPage from './components/disaster/NatAdminDisasterPreventionEditPage'
import NatAdminDisasterModeSettingPage from './components/disaster/NatAdminDisasterModeSettingPage'
import NatAdminDisasterTopicPage from './components/disaster/NatAdminDisasterTopicPage'
import NatAdminDisasterModeReleasePage from './components/disaster/NatAdminDisasterModeReleasePage'

interface Props {
    adminAuthRepo: AdminAuthRepository
    condominiumRepo: NatCondominiumRepo
    adminUserRepo: NatAdminUserRepo
    roomToResidentRepo: NatRoomToResidentRepo
    condominiumGroupRepo: NatCondominiumGroupRepo
    scheduleRepo: NatScheduleRepo
    eventRepo: NatEventRepo
    ridgeRepo: NatRidgeRepo
    messageRepo: NatMessageRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    holidayMasterRepo: NatHolidayMasterRepo
    lifeNoteRepo: NatLifeNoteRepo
    eventEmitter: EventEmitterExAdmin
    sessionRepo: NatSessionRepo
    loginBeforeMessageRepo: NatLoginBeforeMessageRepo
    closedSettingRepo: NatClosedSettingRepo
    menuMasterRepo: NatMenuMasterRepo
    useFunctionMasterRepo: NatUseFunctionMasterRepo
    condominiumAuthoritySettingRepo: NatCondominiumAuthoritySettingRepo
    ownerCondominiumRepo: NatOwnerCondominiumRepo
    apartAssocInfoRepo: NatApartAssocInfoRepo
    facilityRepo: NatFacilityRepo
    facilityReserveRepo: NatFacilityReserveRepo
    facilitiesRepo: FacilitiesRepository
    reservationModel: ReserveFacilityModel
    holidaysRepo: HolidaysRepository
    reservationsRepoForAdmin: ReservationsRepositoryForAdmin
    bulletinBoardRepo: NatBulletinBoardRepo
    personalInfoExtractHistoryRepo: PersonalInfoExtractHistoryRepo,
    areaCodeRepo: NatAreaCodeRepo
    maintenanceSettingMasterRepo: NatMaintenanceSettingMasterRepo
    extractHistoryRepo: NatExtractHistoryRepo
    applicationRepo: NatApplicationRepo
    fileRepo: NatFileRepo
    assocWorkReportRepo: NatAssocWorkReportRepo
    ownershipTransfersRepo: NatOwnershipTransfersRepo
    roomNumberRepo: NatRoomNumberRepo
    assocManagementRepo: AssocManagementRepository
    adminSessionUtil: AdminSessionUtil
    residentUserRepo: NatResidentUserRepo
    disasterRepo: NatDisasterRepo
}

let refreshToken = ''
const makeRefreshToken = (location: Location) => {
    refreshToken = (location?.state?.refreshToken || refreshToken)
    return refreshToken
}

export function SubRoutesAdmin(routesProps: Props): ReactElement {
    const {
        adminAuthRepo,
        eventEmitter,
        condominiumRepo,
        adminUserRepo,
        roomToResidentRepo,
        condominiumGroupRepo,
        scheduleRepo,
        eventRepo,
        ridgeRepo,
        messageRepo,
        currentDateTimeRepo,
        holidayMasterRepo,
        lifeNoteRepo,
        sessionRepo,
        loginBeforeMessageRepo,
        closedSettingRepo,
        menuMasterRepo,
        useFunctionMasterRepo,
        condominiumAuthoritySettingRepo,
        ownerCondominiumRepo,
        apartAssocInfoRepo,
        facilityRepo,
        facilityReserveRepo,
        facilitiesRepo,
        reservationModel,
        holidaysRepo,
        reservationsRepoForAdmin,
        bulletinBoardRepo,
        personalInfoExtractHistoryRepo,
        areaCodeRepo,
        maintenanceSettingMasterRepo,
        extractHistoryRepo,
        applicationRepo,
        fileRepo,
        assocWorkReportRepo,
        ownershipTransfersRepo,
        roomNumberRepo,
        assocManagementRepo,
        adminSessionUtil,
        residentUserRepo,
    disasterRepo
    }: Props = routesProps
    return (<>
    <Route
        path="/admin/error"
        element={<RouterPropsInjector>{(props) =>
            <NatAdminSystemErrorPage
                supportSp
                eventEmitter={eventEmitter}
                navigate={props.navigate}
                location={props.location}
                pageTitle={'素敵ネット管理画面'}
            />
        }</RouterPropsInjector>}
    />
    <Route
        path="/admin/sso/azure/redirect"
        element={<RouterPropsInjector>{(props) =>
            <NatAdSSOLoginRedirectPage
                eventEmitter={eventEmitter}
                navigate={props.navigate}
                location={props.location}
                pageTitle={'素敵ネット管理画面'}
                headingAreaTitle={'長谷工グループ認証リダイレクト'}
            />
        }</RouterPropsInjector>}
    />
    <Route
        path="/admin/login-portal"
        element={<RouterPropsInjector>{(props) =>
            <AdminLoginPortalPage
                supportSp
                adminAuthRepo={adminAuthRepo}
                eventEmitter={eventEmitter}
                navigate={props.navigate}
                location={props.location}
                isBeforeLoginPage
                pageTitle={'素敵ネット管理画面'}
            />
        }</RouterPropsInjector>}
    />
    <Route
        path="/admin/login"
        element={<RouterPropsInjector>{(props) =>
            <NatAdminLoginPage
                supportSp
                adminAuthRepo={adminAuthRepo}
                menuMasterRepo={menuMasterRepo}
                currentDateTimeRepo={currentDateTimeRepo}
                eventEmitter={eventEmitter}
                navigate={props.navigate}
                location={props.location}
                sessionRepo={sessionRepo}
                isBeforeLoginPage
                pageTitle={'素敵ネット管理画面'}
            />
        }</RouterPropsInjector>}
    />
    <Route
        path="/admin/assoc/login"
        element={<RouterPropsInjector>{(props) =>
            <NatAssocLoginPage
                supportSp
                adminAuthRepo={adminAuthRepo}
                menuMasterRepo={menuMasterRepo}
                currentDateTimeRepo={currentDateTimeRepo}
                eventEmitter={eventEmitter}
                navigate={props.navigate}
                location={props.location}
                sessionRepo={sessionRepo}
                pageTitle={'素敵ネット管理画面'}
                isBeforeLoginPage
                residentUserRepo={residentUserRepo}
            />
        }</RouterPropsInjector>}
    />
    <Route
        path="/admin/changePassword"
        element={<RouterPropsInjector>{(props) =>
            <NatAdminChangePasswordInputPage
                supportSp
                adminUserRepo={adminUserRepo}
                eventEmitter={eventEmitter}
                navigate={props.navigate}
                location={props.location}
                pageTitle={'素敵ネット管理画面'}
                headingAreaTitle={'パスワード変更'}
                isBeforeLoginPage
            />
        }</RouterPropsInjector>}
    />
        <Route
            path="/admin/condominiumGroupEdit"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminCondominiumGroupEditPage
                    condominiumGroupRepo={condominiumGroupRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'物件グループ設定 | 素敵ネット管理画面'}
                    headingAreaTitle={'物件グループ設定'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiumList"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminCondominiumListPage
                    CondominiumRepo={condominiumRepo}
                    CondominiumGroupRepo={condominiumGroupRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'物件検索 | 素敵ネット管理画面'}
                    headingAreaTitle={'物件一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominium/:condominiumCd"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminCondominiumPage
                    condominiumCd={props.params.condominiumCd!}
                    condominiumRepo={condominiumRepo}
                    condominiumAuthoritySettingRepo={condominiumAuthoritySettingRepo}
                    useFunctionMasterRepo={useFunctionMasterRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'物件詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'物件詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiumRegister"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminCondominiumRegisterPage
                    condominiumRepo={condominiumRepo}
                    condominiumGroupRepo={condominiumGroupRepo}
                    useFunctionMasterRepo={useFunctionMasterRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'物件登録 | 素敵ネット管理画面'}
                    headingAreaTitle={'物件登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiumEdit/:condominiumCd"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminCondominiumEditPage
                    condominiumCd={props.params.condominiumCd!}
                    condominiumRepo={condominiumRepo}
                    condominiumGroupRepo={condominiumGroupRepo}
                    useFunctionMasterRepo={useFunctionMasterRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'物件編集 | 素敵ネット管理画面'}
                    headingAreaTitle={'物件編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/facilityReserveList"
            element={<RouterPropsInjector>{(props) =>
                <NatFacilityReserveListPage
                    facilityRepo={facilityRepo}
                    facilitiesRepo={facilitiesRepo}
                    RidgeRepo={ridgeRepo}
                    RoomToResidentRepo={roomToResidentRepo}
                    facilityReserveRepo={facilityReserveRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'施設予約検索 | 素敵ネット管理画面'}
                    headingAreaTitle={'施設予約検索'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/facilityReserve/:facilityId/:facilityReserveId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminFacilityReservePage
                    facilityReserveRepo={facilityReserveRepo}
                    facilityId={props.params.facilityId!}
                    facilityReserveId={props.params.facilityReserveId!}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'施設予約詳細  | 素敵ネット管理画面'}
                    headingAreaTitle={'施設予約詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/facilityReserveEdit/:facilityId/:facilityReserveId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminFacilityReserveEditPage
                    reservationsRepositoryForAdmin={reservationsRepoForAdmin}
                    facilityReserveRepo={facilityReserveRepo}
                    RidgeRepo={ridgeRepo}
                    RoomToResidentRepo={roomToResidentRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    facilityId={props.params.facilityId!}
                    facilityReserveId={props.params.facilityReserveId!}
                    reservationModel={reservationModel}
                    holidaysRepo={holidaysRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'施設予約編集 | 素敵ネット管理画面'}
                    headingAreaTitle={'施設予約編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominium/facilityReserveIntroductory/:condominiumCd"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminCondominiumFacilityReserveIntroductoryPage
                    condominiumCd={props.params.condominiumCd!}
                    condominiumRepo={condominiumRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'施設全体説明 | 素敵ネット管理画面'}
                    headingAreaTitle={'施設全体説明'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominium/facilityReserve/billingData"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminFacilityReserveBillingDataPage
                    facilityReserveRepo={facilityReserveRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumRepo={condominiumRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'請求データ出力 | 素敵ネット管理画面'}
                    headingAreaTitle={'請求データ出力'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/facilities/:facilityId/introductory"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminFacilityIntroductoryPage
                    condominiumCd={props.params.condominiumCd!}
                    facilityId={props.params.facilityId!}
                    facilityRepo={facilityRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'施設説明文詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'施設紹介文詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/facilities/:facilityId/introductoryEdit"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminFacilityIntroductoryEditPage
                    condominiumCd={props.params.condominiumCd!}
                    facilityId={props.params.facilityId!}
                    facilityRepo={facilityRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'施設説明文編集 | 素敵ネット管理画面'}
                    headingAreaTitle={'施設紹介文編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/additionalBillingList"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminAdditionalBillingListPage
                    RidgeRepo={ridgeRepo}
                    RoomToResidentRepo={roomToResidentRepo}
                    facilityReserveRepo={facilityReserveRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'追加課金検索 | 素敵ネット管理画面'}
                    headingAreaTitle={'追加課金一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/additionalBilling/:facilityReserveId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminAdditionalBillingPage
                    facilityReserveRepo={facilityReserveRepo}
                    facilityReserveId={props.params.facilityReserveId!}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'追加課金詳細  | 素敵ネット管理画面'}
                    headingAreaTitle={'追加課金詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/additionalBillingRegister"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminAdditionalBillingegisterPage
                    facilityRepo={facilityRepo}
                    facilitiesRepo={facilitiesRepo}
                    facilityReserveRepo={facilityReserveRepo}
                    RidgeRepo={ridgeRepo}
                    RoomToResidentRepo={roomToResidentRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'追加課金登録 | 素敵ネット管理画面'}
                    headingAreaTitle={'追加課金登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/additionalBillingEdit/:facilityReserveId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminAdditionalBillingEditPage
                    facilityRepo={facilityRepo}
                    facilitiesRepo={facilitiesRepo}
                    facilityReserveRepo={facilityReserveRepo}
                    RidgeRepo={ridgeRepo}
                    RoomToResidentRepo={roomToResidentRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    facilityReserveId={props.params.facilityReserveId!}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'追加課金編集 | 素敵ネット管理画面'}
                    headingAreaTitle={'追加課金編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/adminUserList"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminAdminUserListPage
                    AdminUserRepo={adminUserRepo}
                    CondominiumGroupRepo={condominiumGroupRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'管理者ユーザ検索 | 素敵ネット管理画面'}
                    headingAreaTitle={'管理者ユーザ一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/adminUserRegister"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminAdminUserRegisterPage
                    CondominiumRepo={condominiumRepo}
                    AdminUserRepo={adminUserRepo}
                    CondominiumGroupRepo={condominiumGroupRepo}
                    RidgeRepo={ridgeRepo}
                    RoomToResidentRepo={roomToResidentRepo}
                    OwnerCondominiumRepo={ownerCondominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'管理者ユーザ登録 | 素敵ネット管理画面'}
                    headingAreaTitle={'管理者ユーザ登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/adminUserEdit/:adminId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminAdminUserEditPage
                    adminId={props.params.adminId!}
                    condominiumRepo={condominiumRepo}
                    adminUserRepo={adminUserRepo}
                    condominiumGroupRepo={condominiumGroupRepo}
                    ridgeRepo={ridgeRepo}
                    roomToResidentRepo={roomToResidentRepo}
                    ownerCondominiumRepo={ownerCondominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'管理者ユーザ編集 | 素敵ネット管理画面'}
                    headingAreaTitle={'管理者ユーザ編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/adminUser/:adminId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminAdminUserPage
                    adminId={props.params.adminId!}
                    AdminUserRepo={adminUserRepo}
                    OwnerCondominiumRepo={ownerCondominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'管理者ユーザ詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'管理者ユーザ詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/residentUserList"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminResidentUserListPage
                    RoomToResidentRepo={roomToResidentRepo}
                    CondominiumGroupRepo={condominiumGroupRepo}
                    RidgeRepo={ridgeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'居住者ユーザ検索 | 素敵ネット管理画面'}
                    headingAreaTitle={'居住者ユーザ一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/residentUserStatusConfirmation"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminResidentUserStatusConfirmationPage
                    roomToResidentRepo={roomToResidentRepo}
                    ridgeRepo={ridgeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'居住者ユーザ状況確認 | 素敵ネット管理画面'}
                    headingAreaTitle={'居住者ユーザ状況確認'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/residentUserRegister"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminResidentUserRegisterPage
                    condominiumRepo={condominiumRepo}
                    RoomToResidentRepo={roomToResidentRepo}
                    RidgeRepo={ridgeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'居住者ユーザ新規登録  | 素敵ネット管理画面'}
                    headingAreaTitle={'居住者ユーザ新規登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/residentUser/:condominiumCd/:ridgeCd/:roomNumber/:seq"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminResidentUserDetailsPage
                    condominiumCd={props.params.condominiumCd!}
                    ridgeCd={props.params.ridgeCd!}
                    roomNumber={props.params.roomNumber!}
                    seq={props.params.seq!}
                    roomToResidentRepo={roomToResidentRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'居住者ユーザ詳細  | 素敵ネット管理画面'}
                    headingAreaTitle={'居住者ユーザ詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/residentUserEdit/:condominiumCd/:ridgeCd/:roomNumber/:seq"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminResidentUserEditPage
                    condominiumCd={props.params.condominiumCd!}
                    ridgeCd={props.params.ridgeCd!}
                    roomNumber={props.params.roomNumber!}
                    seq={props.params.seq!}
                    roomToResidentRepo={roomToResidentRepo}
                    condominiumRepo={condominiumRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'居住者ユーザ編集  | 素敵ネット管理画面'}
                    headingAreaTitle={'居住者ユーザ編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/residentUserEditForAdminName/:condominiumCd/:ridgeCd/:roomNumber/:seq"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminResidentUserEditForAdminNamePage
                    condominiumCd={props.params.condominiumCd!}
                    ridgeCd={props.params.ridgeCd!}
                    roomNumber={props.params.roomNumber!}
                    seq={props.params.seq!}
                    roomToResidentRepo={roomToResidentRepo}
                    condominiumRepo={condominiumRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'居住者ユーザ編集（管理者確認用氏名）  | 素敵ネット管理画面'}
                    headingAreaTitle={'居住者ユーザ編集（管理者確認用氏名）'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/bulkUpdate/residentUser"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminResidentUserBulkUpdatePage
                    RoomToResidentRepo={roomToResidentRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'居住者ユーザ一括更新  | 素敵ネット管理画面'}
                    headingAreaTitle={'居住者ユーザ一括更新'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/residentUser/apply"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminResidentUserApplyPage
                    roomToResidentRepo={roomToResidentRepo}
                    ridgeRepo={ridgeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'居住者ユーザ申請 | 素敵ネット管理画面'}
                    headingAreaTitle={'居住者ユーザ申請'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/residentUser/applyEdit/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminResidentUserApplyEditPage
                    applyId={Number(props.params.applyId)}
                    roomToResidentRepo={roomToResidentRepo}
                    ridgeRepo={ridgeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'居住者ユーザ申請編集 | 素敵ネット管理画面'}
                    headingAreaTitle={'居住者ユーザ申請編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/residentUser/applyList"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminResidentUserApplyList
                    currentDateTimeRepo={currentDateTimeRepo}
                    roomToResidentRepo={roomToResidentRepo}
                    ridgeRepo={ridgeRepo}
                    condominiumGroupRepo={condominiumGroupRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'居住者ユーザ申請一覧 | 素敵ネット管理画面'}
                    headingAreaTitle={'居住者ユーザ申請一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/residentUser/apply/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminResidentUserApply
                    applyId={Number(props.params.applyId)}
                    roomToResidentRepo={roomToResidentRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'居住者ユーザ申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'居住者ユーザ申請詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/residentUser/noticeApply/:seq"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminResidentAuthKeyNoticeApply
                    seq={Number(props.params.seq)}
                    roomToResidentRepo={roomToResidentRepo}
                    condominiumRepo={condominiumRepo}
                    adminUserRepo={adminUserRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'居住者ユーザ申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'居住者ユーザ申請詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/messageList"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminMessageListPage
                    messageRepo={messageRepo}
                    condominiumGroupRepo={condominiumGroupRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'メッセージ検索 | 素敵ネット管理画面'}
                    headingAreaTitle={'メッセージ一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/messageRegister"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminMessageRegisterPage
                    messageId={props.location.state}
                    condominiumRepo={condominiumRepo}
                    messageRepo={messageRepo}
                    condominiumGroupRepo={condominiumGroupRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'メッセージ登録 | 素敵ネット管理画面'}
                    headingAreaTitle={'メッセージ登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/messageEdit/:messageId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminMessageEditPage
                    messageId={props.params.messageId!}
                    condominiumRepo={condominiumRepo}
                    messageRepo={messageRepo}
                    condominiumGroupRepo={condominiumGroupRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'メッセージ編集 | 素敵ネット管理画面'}
                    headingAreaTitle={'メッセージ編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/message/:messageId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminMessagePage
                    messageId={props.params.messageId!}
                    messageRepo={messageRepo}
                    condominiumGroupRepo={condominiumGroupRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'メッセージ詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'メッセージ詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/scheduleRegister"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminScheduleRegisterPage
                    condominiumRepo={condominiumRepo}
                    condominiumGroupRepo={condominiumGroupRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    scheduleRepo={scheduleRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'スケジュール登録 | 素敵ネット管理画面'}
                    headingAreaTitle={'スケジュール登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/scheduleEdit/:scheduleId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminScheduleUpdatePage
                    scheduleId={props.params.scheduleId!}
                    condominiumRepo={condominiumRepo}
                    condominiumGroupRepo={condominiumGroupRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    scheduleRepo={scheduleRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'スケジュール編集 | 素敵ネット管理画面'}
                    headingAreaTitle={'スケジュール編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/lifeNoteList"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminLifeNoteListPage
                    lifeNoteRepo={lifeNoteRepo}
                    condominiumGroupRepo={condominiumGroupRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'生活便利帳検索 | 素敵ネット管理画面'}
                    headingAreaTitle={'生活便利帳一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/lifeNote/:lifeNoteId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminLifeNoteDetailsPage
                    lifeNoteId={props.params.lifeNoteId!}
                    lifeNoteRepo={lifeNoteRepo}
                    condominiumRepo={condominiumRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'生活便利帳詳細  | 素敵ネット管理画面'}
                    headingAreaTitle={'生活便利帳詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/lifeNoteRegister"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminLifeNoteRegisterPage
                    condominiumRepo={condominiumRepo}
                    condominiumGroupRepo={condominiumGroupRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    lifeNoteRepo={lifeNoteRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'生活便利帳登録 | 素敵ネット管理画面'}
                    headingAreaTitle={'生活便利帳登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/lifeNoteEdit/:lifeNoteId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminLifeNoteEditPage
                    lifeNoteId={props.params.lifeNoteId!}
                    condominiumRepo={condominiumRepo}
                    condominiumGroupRepo={condominiumGroupRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    lifeNoteRepo={lifeNoteRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'生活便利帳編集 | 素敵ネット管理画面'}
                    headingAreaTitle={'生活便利帳編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/apartAssocList"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminApartAssocInfoListPage
                    apartAssocInfoRepo={apartAssocInfoRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'マンション・管理組合情報検索 | 素敵ネット管理画面'}
                    headingAreaTitle={'マンション・管理組合情報検索'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/apartAssoc/:apartAssocId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminApartAssocInfoDetailsPage
                    apartAssocInfoRepo={apartAssocInfoRepo}
                    apartAssocId={props.params.apartAssocId!}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'マンション・管理組合情報詳細  | 素敵ネット管理画面'}
                    headingAreaTitle={'マンション・管理組合情報詳細 '}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/apartAssocRegister"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminApartAssocInfoRegisterPage
                    apartAssocInfoRepo={apartAssocInfoRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'マンション・管理組合情報登録 | 素敵ネット管理画面'}
                    headingAreaTitle={'マンション・管理組合情報登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/apartAssocEdit/:apartAssocId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminApartAssocInfoEditPage
                    apartAssocId={props.params.apartAssocId!}
                    apartAssocInfoRepo={apartAssocInfoRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'マンション・管理組合情報編集 | 素敵ネット管理画面'}
                    headingAreaTitle={'マンション・管理組合情報編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/loginBeforeMessage/:loginBeforeMessageMasterId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminLoginBeforeMessagePage
                    loginBeforeMessageMasterId={props.params.loginBeforeMessageMasterId!}
                    loginBeforeMessageRepo={loginBeforeMessageRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'ログイン前メッセージ詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'ログイン前メッセージ詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/loginBeforeMessageList"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminLoginBeforeMessageListPage
                    loginBeforeMessageRepo={loginBeforeMessageRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'ログイン前メッセージ一覧 | 素敵ネット管理画面'}
                    headingAreaTitle={'ログイン前メッセージ一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/loginBeforeMessageRegister"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminLoginBeforeMessageRegisterPage
                    loginBeforeMessageRepo={loginBeforeMessageRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'ログイン前メッセージ登録 | 素敵ネット管理画面'}
                    headingAreaTitle={'ログイン前メッセージ登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/loginBeforeMessageEdit/:loginBeforeMessageId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminLoginBeforeMessageEditPage
                    loginBeforeMessageMasterId={props.params.loginBeforeMessageId!}
                    loginBeforeMessageRepo={loginBeforeMessageRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'ログイン前メッセージ編集 | 素敵ネット管理画面'}
                    headingAreaTitle={'ログイン前メッセージ編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route

            path="/admin/calendar"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminCalendarPage
                    scheduleRepo={scheduleRepo}
                    eventRepo={eventRepo}
                    condominiumGroupRepo={condominiumGroupRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidayMasterRepo={holidayMasterRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'スケジュール参照 | 素敵ネット管理画面'}
                    headingAreaTitle={'スケジュール'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/schedule/:scheduleId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminScheduleDetailsPage
                    scheduleId={props.params.scheduleId!}
                    scheduleRepo={scheduleRepo}
                    condominiumRepo={condominiumRepo}
                    eventRepo={eventRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'スケジュール詳細  | 素敵ネット管理画面'}
                    headingAreaTitle={'スケジュール詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/event/:scheduleId/:seq"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminEventDetailsPage
                    scheduleId={props.params.scheduleId!}
                    seq={props.params.seq!}
                    scheduleRepo={scheduleRepo}
                    condominiumRepo={condominiumRepo}
                    eventRepo={eventRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'イベント詳細  | 素敵ネット管理画面'}
                    headingAreaTitle={'イベント詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/eventEdit/:scheduleId/:seq"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminEventEditPage
                    scheduleId={props.params.scheduleId!}
                    seq={props.params.seq!}
                    scheduleRepo={scheduleRepo}
                    condominiumRepo={condominiumRepo}
                    eventRepo={eventRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'イベント編集  | 素敵ネット管理画面'}
                    headingAreaTitle={'イベント編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/closedSetting"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminClosedSettingPage
                    currentDateTimeRepo={currentDateTimeRepo}
                    closedSettingRepo={closedSettingRepo}
                    facilityReserveRepo={facilityReserveRepo}
                    personalInfoExtractHistoryRepo={personalInfoExtractHistoryRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'休館設定 | 素敵ネット管理画面'}
                    headingAreaTitle={'休館設定'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiumAuthoritySetting/:condominiumCd"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminCondominiumAuthoritySettingPage
                    condominiumCd={props.params.condominiumCd!}
                    condominiumAuthoritySettingRepo={condominiumAuthoritySettingRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'権限編集 | 素敵ネット管理画面'}
                    headingAreaTitle={'権限編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/outputAuthenticationKey"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminAuthenticationKeyDownloadPage
                    roomToResidentRepo={roomToResidentRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'認証キー一括出力 | 素敵ネット管理画面'}
                    headingAreaTitle={'認証キー一括出力'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/extractHistory/residentUserList"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminExtractHistoryList
                    extractHistoryRepo={extractHistoryRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'居住者ユーザリスト出力 | 素敵ネット管理画面'}
                    headingAreaTitle={'居住者ユーザリスト出力'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/bulletinBoardThreadList"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminBulletinBoardThreadListPage
                    bulletinBoardRepo={bulletinBoardRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'スレッド検索 | 素敵ネット管理画面'}
                    headingAreaTitle={'スレッド一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/bulletinBoardThread/:threadId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminBulletinBoardThreadPage
                    threadId={Number(props.params.threadId!)}
                    bulletinBoardRepo={bulletinBoardRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'スレッド詳細・コメント一覧 | 素敵ネット管理画面'}
                    headingAreaTitle={'スレッド詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/bulletinBoardThread/:threadId/:commentId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminBulletinBoardThreadCommentPage
                    threadId={Number(props.params.threadId!)}
                    commentId={Number(props.params.commentId!)}
                    bulletinBoardRepo={bulletinBoardRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'コメント詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'コメント詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/bulletinBoardThreadRegister"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminBulletinBoardThreadRegisterPage
                    bulletinBoardRepo={bulletinBoardRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'スレッド登録 | 素敵ネット管理画面'}
                    headingAreaTitle={'スレッド登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/bulletinBoardThreadCommentRegister/:threadId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminBulletinBoardThreadCommentRegisterPage
                    threadId={Number(props.params.threadId!)}
                    bulletinBoardRepo={bulletinBoardRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'コメント登録 | 素敵ネット管理画面'}
                    headingAreaTitle={'コメント登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/areaCodeList"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminAreaCodeListPage
                    areaCodeRepo={areaCodeRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'地域コード一覧 | 素敵ネット管理画面'}
                    headingAreaTitle={'地域コード一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/areaCode/:areaId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminAreaCodePage
                    areaId={Number(props.params.areaId!)}
                    areaCodeRepo={areaCodeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'地域コード詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'地域コード詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/areaCodeRegister"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminAreaCodeRegisterPage
                    areaCodeRepo={areaCodeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'地域コード登録 | 素敵ネット管理画面'}
                    headingAreaTitle={'地域コード登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/areaCodeEdit/:areaId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminAreaCodeEditPage
                    areaId={Number(props.params.areaId!)}
                    areaCodeRepo={areaCodeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'地域コード編集 | 素敵ネット管理画面'}
                    headingAreaTitle={'地域コード編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/maintenance/resident"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminMaintenanceForResidentPage
                    maintenanceSettingMasterRepo={maintenanceSettingMasterRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'メンテナンスモード設定 | 素敵ネット管理画面'}
                    headingAreaTitle={'メンテナンスモード設定'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/contactAddressOnEmergencies/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminContactAddressOnEmergencyPage
                    supportSp
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'緊急時連絡表_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/applications"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminApplicationPage
                    supportSp
                    condominiumGroupRepo={condominiumGroupRepo}
                    RidgeRepo={ridgeRepo}
                    applicationRepo={applicationRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'申請状況一覧 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請状況一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/parkingUses/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminParkingUsesPage
                    supportSp
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'駐車場使用申込_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/parkingUsesChange/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminParkingUsesChangePage
                    supportSp
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'自動車変更届_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/parkingUsesWithdrawal/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminParkingUsesWithdrawalPage
                    supportSp
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'駐車場使用契約解約届_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/bicycleParkingUses/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminBicycleParkingUseApplyPage
                    supportSp
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'駐輪場使用申込_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/bicycleParkingUsesWithdrawal/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminBicycleParkingUseWithdrawalPage
                    supportSp
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'駐輪場使用許可解除申込_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/bikeParkingUses/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminBikeParkingUseApplyPage
                    supportSp
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'バイク置場使用申込_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/bikeParkingUsesChange/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminBikeParkingUseChangeApplyPage
                    supportSp
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'バイク変更届_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/bikeParkingUsesWithdrawal/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminBikeParkingUseWithdrawalApplyPage
                    supportSp
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'バイク置場使用契約解約届_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/breedingPets/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminPetBreedingPage
                    supportSp
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    fileRepo={fileRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'ペット飼育申請_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/petMedicalCheckUpReport/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminPetMedicalCheckUpReportPage
                    supportSp
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    fileRepo={fileRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'健康診断報告書_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/breedingPetsStop/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminPetBreedingStopPage
                    supportSp
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'ペット飼育中止届_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/constructions/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminConstructionsPage
                    supportSp
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'工事申請書_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/constructionsComplete/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminConstructionCompletePage
                    supportSp
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'工事完了届_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/windowFilmAttaches/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminWindowFilmAttachPage
                    supportSp
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'窓ガラスフィルム貼付申請_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/inspections/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminBrowsePage
                    supportSp
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'閲覧申請書_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/longAbsence/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminLongAbsencePage
                    supportSp
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'長期不在届_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/heavyLoadsCarries/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminHeavyLoadsCarryPage
                    supportSp
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'重量物搬入等届_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/report-publishing-settings"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminReportPublishingScopePage
                    condominiumCd={props.params.condominiumCd!}
                    assocWorkReportRepo={assocWorkReportRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'報告書の公開範囲 | 素敵ネット管理画面'}
                    headingAreaTitle={'報告書の公開範囲'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/applications/ownershipTransferList"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminOwnershipTransferListPage
                    condominiumGroupRepo={condominiumGroupRepo}
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'組合員資格変更届一覧 | 素敵ネット管理画面'}
                    headingAreaTitle={'組合員資格変更届一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/ownershipTransfers/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatOwnershipTransferPage
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'組合員資格変更届詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'組合員資格変更届詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/applications/ownershipTransfers/register"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminOwnershipTransfersRegisterPage
                    condominiumRepo={condominiumRepo}
                    condominiumGroupRepo={condominiumGroupRepo}
                    ridgeRepo={ridgeRepo}
                    roomNumberRepo={roomNumberRepo}
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'組合員資格変更届発行 | 素敵ネット管理画面'}
                    headingAreaTitle={'組合員資格変更届発行'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/ownershipTransfers/:applyId/completed"
            element={<RouterPropsInjector>{(props) =>
                <NatOwnershipTransferCompletedPage
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'組合員資格変更届_申請詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/assocStatusConfirmation"
            element={<RouterPropsInjector>{(props) =>
                <AdminAssocStatusListPage
                    condominiumGroupRepo={condominiumGroupRepo}
                    condominiumRepo={condominiumRepo}
                    assocManagementRepo={assocManagementRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    adminSessionUtil={adminSessionUtil}
                    residentUserRepo={residentUserRepo}
                    pageTitle={'管理組合の状況確認 | 素敵ネット管理画面'}
                    headingAreaTitle={'管理組合の状況確認'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/applications/userRegistrationApplyList"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminUserRegistrationApplyListPage
                   condominiumGroupRepo={condominiumGroupRepo}
                   applicationRepo={applicationRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'申請状況一覧 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請状況一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/applications/userRegistrationApply/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminUserRegistrationApplyPage
                    key={makeRefreshToken(props.location)}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    applicationRepo={applicationRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'申請内容詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'申請内容詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/assoc/loginRedirectCushion"
            element={<RouterPropsInjector>{(props) =>
                <NatAssocAfterLoginCushion
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    residentUserRepo={residentUserRepo}
                    roomToResidentRepo={roomToResidentRepo}
                    adminAuthRepo={adminAuthRepo}
                    menuMasterRepo={menuMasterRepo}
                    sessionRepo={sessionRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    pageTitle={'ログインリダイレクトクッション | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/disasters/preventions"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminDisasterPreventionsPage
                    condominiumCd={props.params.condominiumCd!}
                    condominiumRepo={condominiumRepo}
                    disasterRepo={disasterRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'防災情報一覧 | 素敵ネット管理画面'}
                    headingAreaTitle={'防災情報一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/disasters/preventions/:disasterPreventionId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminDisasterPreventionsDetailsPage
                    condominiumCd={props.params.condominiumCd!}
                    disasterPreventionId={Number(props.params.disasterPreventionId!)}
                    condominiumRepo={condominiumRepo}
                    disasterRepo={disasterRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'防災情報詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'防災情報詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/disasters/topics/register"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminDisasterTopicRegister
                    condominiumCd={props.params.condominiumCd!}
                    disasterRepo={disasterRepo}
                    condominiumRepo={condominiumRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'トピック登録 | 素敵ネット管理画面'}
                    headingAreaTitle={'トピック登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/disasters/mode/statuses"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminDisasterModeStatusListPage
                    condominiumGroupRepo={condominiumGroupRepo}
                    condominiumRepo={condominiumRepo}
                    disasterRepo={disasterRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'モード設定状況一覧 | 素敵ネット管理画面'}
                    headingAreaTitle={'モード設定状況一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/disasters/preventionRegister"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminDisasterPreventionRegisterPage
                    condominiumCd={props.params.condominiumCd!}
                    condominiumRepo={condominiumRepo}
                    disasterRepo={disasterRepo}
                    fileRepo={fileRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'防災情報登録 | 素敵ネット管理画面'}
                    headingAreaTitle={'防災情報登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/disasters/comments"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminDisasterTopicListPage
                    condominiumCd={props.params.condominiumCd!}
                    activeTab={'comments'}
                    condominiumRepo={condominiumRepo}
                    disasterRepo={disasterRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'災害時情報共有一覧 | 素敵ネット管理画面'}
                    headingAreaTitle={'災害時情報共有一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/disasters/topics"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminDisasterTopicListPage
                    condominiumCd={props.params.condominiumCd!}
                    activeTab={'topics'}
                    condominiumRepo={condominiumRepo}
                    disasterRepo={disasterRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'災害時情報共有一覧 | 素敵ネット管理画面'}
                    headingAreaTitle={'災害時情報共有一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/disasters/topics/:topicId/edit"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminDisasterTopicEdit
                    condominiumCd={props.params.condominiumCd!}
                    disasterRepo={disasterRepo}
                    topicId={Number(props.params.topicId!)}
                    condominiumRepo={condominiumRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'トピック編集 | 素敵ネット管理画面'}
                    headingAreaTitle={'トピック編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/disasters/preventionEdit/:disasterPreventionId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminDisasterPreventionEditPage
                    condominiumCd={props.params.condominiumCd!}
                    disasterPreventionId={Number(props.params.disasterPreventionId!)}
                    condominiumRepo={condominiumRepo}
                    disasterRepo={disasterRepo}
                    fileRepo={fileRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'防災情報編集 | 素敵ネット管理画面'}
                    headingAreaTitle={'防災情報編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/disasters/mode/setting"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminDisasterModeSettingPage
                    condominiumGroupRepo={condominiumGroupRepo}
                    condominiumRepo={condominiumRepo}
                    disasterRepo={disasterRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'災害時モード設定 | 素敵ネット管理画面'}
                    headingAreaTitle={'災害時モード設定'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/disasters/topics/:topicId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminDisasterTopicPage
                    condominiumCd={props.params.condominiumCd!}
                    topicId={Number(props.params.topicId!)}
                    condominiumRepo={condominiumRepo}
                    disasterRepo={disasterRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'トピック詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'トピック詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/disasters/topics/:topicId/comments/:commentId"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminDisasterTopicPage
                    condominiumCd={props.params.condominiumCd!}
                    topicId={Number(props.params.topicId!)}
                    commentId={Number(props.params.commentId!)}
                    condominiumRepo={condominiumRepo}
                    disasterRepo={disasterRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'コメント詳細 | 素敵ネット管理画面'}
                    headingAreaTitle={'コメント詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/disasters/mode/release"
            element={<RouterPropsInjector>{(props) =>
                <NatAdminDisasterModeReleasePage
                    condominiumGroupRepo={condominiumGroupRepo}
                    condominiumRepo={condominiumRepo}
                    disasterRepo={disasterRepo}
                    eventEmitter={eventEmitter}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'災害時モード解除 | 素敵ネット管理画面'}
                    headingAreaTitle={'災害時モード解除'}
                />
            }</RouterPropsInjector>}
        />

    </>)
}
